import React from 'react';

const AdminSettings: React.FC = () => {
  return (
    <div className="admin-page">
      <h2>Admin Settings</h2>
      <p>This page would contain administrative settings for the website.</p>
    </div>
  );
};

export default AdminSettings;